import { z } from 'zod'

export const licenseValidation = z.object({
  activationExpiryTime: z.date(),
  certNum: z.string().min(1, { message: 'Cert Number must not be blank' }).max(30, { message: 'Cert Number must not be longer than 30 characters' }),
  remarks: z.string().min(1, { message: 'Remarks must not be blank' }).max(255, { message: 'Remarks must not be longer than 255 characters' }),
  productFeatureSettings: z.array(
    z.object({
      featureId: z.string(),
      featureName: z.string(),
      featureCode: z.string(), // Added featureCode to the schema
      featureValue: z.string().min(1, { message: 'Value must not be blank' }),
      privileges: z.array(z.string()).optional(),
      type: z.string().optional(), // Added type to match the form structure
    }).refine(
      (data) => {
        if (data.featureValue.trim() === '' || data.type === 'B') {
          return true
        }
        const num = parseFloat(data.featureValue)
        if (isNaN(num)) {
          return false // Invalid number
        }
        if (['MAX_LOGIN_USERS', 'MAX_LOGIN_SESSIONS_PER_USER'].includes(data.featureCode)) {
          return num > 0 // Must be positive
        }
        if (['MAX_IDENTITIES'].includes(data.featureCode)) {
          return num > 9 // Must be positive
        }
        if (['MAX_DOORS'].includes(data.featureCode)) {
          return num > 1 // Must be positive
        }
        return num >= 0 // Can be 0 or positive
      },
      data => ({
        message: ['MAX_LOGIN_USERS', 'MAX_LOGIN_SESSIONS_PER_USER'].includes(data.featureCode)
          ? `${data.featureName} must be at least 1.`
          : data.featureCode === 'MAX_IDENTITIES'
            ? `Must have at least 10 identities.`
            : data.featureCode === 'MAX_DOORS'
              ? `Must have at least 2 doors.`
              : `${data.featureName} must be a non-negative value.`,
        path: ['featureValue'],
      }),
    ),
  ),
  productId: z.string().min(1, { message: 'Must select a product' }),
  siteId: z.string().min(1, { message: 'Must select a site' }),
  clientId: z.string().min(1, { message: 'Must select a client' }),
})

export type LicenseValidation = z.infer<typeof licenseValidation>
